<div class="loader" ngxUiLoaderBlurred blur="5" fgsColor="red">
    <app-menu *ngIf="showTemplate" ></app-menu>
    <router-outlet></router-outlet>
    <app-footer *ngIf="showTemplate"></app-footer>
</div>

<ngx-ui-loader></ngx-ui-loader>